import { UAParser } from "ua-parser-js";
import CheerzApiProvider from "@Providers/CheerzApiProvider";
import { getMetaContent } from "@Utils/meta";

const uaParser = new UAParser();
const device = uaParser.getDevice();
const csrfToken = getMetaContent("csrf-token");
const localeSlug = window.location.pathname.split("/")[1];

const cheerzApiProvider = () => {
  if (!csrfToken) {
    throw new Error("CSRF Token not found");
  }

  return new CheerzApiProvider(localeSlug, csrfToken);
};

const clientId = getMetaContent("instagramApiKey");
const redirectURL = `${window.location.origin}/api/oauth_instagram/callback`;
const scope = "user_profile,user_media";

const authorizationURL =
  clientId &&
  `https://api.instagram.com/oauth/authorize/?client_id=${clientId}&redirect_uri=${redirectURL}&response_type=code&scope=${scope}`;

export function connect(): Promise<string> {
  return new Promise<string | undefined>((resolve, reject) => {
    window.oAuthSuccess = (data) => {
      return resolve(data);
    };
    window.oAuthError = (error) => {
      return reject(new Error(`oauth failed : ${error.title}. ${error.description}`));
    };

    if (!authorizationURL) {
      return;
    }

    if (device.type === "mobile" || device.type === "tablet") {
      window.open(authorizationURL, "_blank");
    } else {
      window.open(authorizationURL, "OAuth", "width=500, height=500");
    }
  }).then((code) =>
    cheerzApiProvider()
      .getProviderToken("instagram", code)
      .then((response) => response.access_token)
  );
}
